var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_Twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u6700\\u7EC8\\u5B9A\\u7A3F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u65B0\\u589E",
    transform: "translate(-575.000000, -913.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_Twitter",
    transform: "translate(575.000000, 913.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#DBA45C",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 39.985176,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.992588,0 C8.91974,0 0,8.92304688 0,20 C0,31.0769531 8.91974,40 19.992588,40 C31.065436,40 39.985176,31.0769531 39.985176,20 C39.985176,8.92304688 31.065436,0 19.992588,0 Z",
    id: "\\u5F62\\u72B6",
    fill: "#0E0905",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "6507242bd3e4e6ff563303fe_twi",
    transform: "translate(10.000000, 11.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L6.18890909,0 L10.6672727,5.83668 L15.832,0 L18.7635455,0 L12.0484545,7.63668 L20,18 L13.8110909,18 L8.91945455,11.62476 L3.32409091,18 L0.392545455,18 L7.53509091,9.82053 L0,0 Z M3.25745455,1.54296 L5.27109091,1.54296 L16.7428182,16.45722 L14.7291818,16.45722 L3.25745455,1.54296 Z",
    id: "\\u5F62\\u72B6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTwitter);
export default __webpack_public_path__ + "static/media/ic_twitter.936f690124cdac7f29dc67b3ef8b4d6c.svg";
export { ForwardRef as ReactComponent };